import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';
import Infinite from 'react-infinite';
import Loading from 'components/Loading';

const ListView = ({ children, loading, needsMore, handleInfiniteLoad }) =>

  <div>
    <MediaQuery minWidth={CUT_POINT}>
      {!loading && children.length === 0 && 'Your search yielded no results.'}
      <Infinite
        useWindowAsScrollContainer
        elementHeight={80}
        infiniteLoadBeginEdgeOffset={0}
        onInfiniteLoad={handleInfiniteLoad}
        isInfiniteLoading={loading}
      >
        {children}
      </Infinite>
    </MediaQuery>
    {/* Below is for mobile */}
    <MediaQuery maxWidth={CUT_POINT - 1}>
      <Infinite
        useWindowAsScrollContainer
        elementHeight={400}
        infiniteLoadBeginEdgeOffset={0}
        onInfiniteLoad={handleInfiniteLoad}
        isInfiniteLoading={loading}
      >
        {children}
      </Infinite>
    </MediaQuery>
    {needsMore ? <Loading message="Loading additional resources..." /> : null }
  </div>;

ListView.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  needsMore: PropTypes.bool,
  handleInfiniteLoad: PropTypes.func.isRequired,
};

export default ListView;



// WEBPACK FOOTER //
// ./client/app/shared/components/ListView/index.jsx